import { api } from "..";
const endpoint = "/api/finished-goods";
const qualityControlEndpoint = "/api/finished-good-quality-control";

export const getFinishedGoodList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const getAllFinishedGoods = async () => {
  return await api.get(`${endpoint}/all`);
};

export const createFinishedGood = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateFinishedGood = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const patchFinishedGood = async (id, data) => {
  return await api.patch(`${endpoint}/${id}`, data);
};

export const uploadFinishedGoodImage = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file, file.name);
  return await api.post(`${endpoint}/${id}/image`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getFinishedGoodImage = async (id) => {
  return await api.get(`${endpoint}/${id}/image`, {
    responseType: "blob",
  });
};

export const deleteFinishedGood = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const getFinishedGoodById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const submitQualityControls = async (finishedGoodId, controlIds) => {
  return await api.post(`${qualityControlEndpoint}/finished-goods/${finishedGoodId}/quality-control`, controlIds);
};

export const getQualityControlsByFinishedGoodId = async (finishedGoodId) => {
  return await api.get(`${qualityControlEndpoint}/finished-goods/${finishedGoodId}`);
};

// SpecificationItem API functions
const specificationItemEndpoint = "/api/SpecificationItem";

export const getSpecificationItemList = async (queryParams) => {
  return await api.get(`${specificationItemEndpoint}`, { params: queryParams });
};

export const getSpecificationItemListShort = async (queryParams) => {
  return await api.get(`${specificationItemEndpoint}/short`, { params: queryParams });
};

export const getSpecificationItemById = async (id) => {
  return await api.get(`${specificationItemEndpoint}/${id}`);
};

export const createSpecificationItem = async (data) => {
  return await api.post(`${specificationItemEndpoint}`, data);
};

export const updateSpecificationItem = async (id, data) => {
  return await api.put(`${specificationItemEndpoint}/${id}`, data);
};

export const patchSpecificationItem = async (id, data) => {
  return await api.patch(`${specificationItemEndpoint}/${id}`, data);
};

export const deleteSpecificationItem = async (id) => {
  return await api.delete(`${specificationItemEndpoint}/${id}`);
};
